import { toNumber } from 'lodash'
import { fetchSearchCategories } from './api'

/**
 * @typedef CategoryElement
 * @property {number} id
 * @property {string} code_name
 * @property {string} human_name
 * @property {string} seoName
 * @property {string} description
 * @property {string|null} marker
 * @property {string[]} tags
 * @property {string[]} rating_categories
 */

/** @type Categories */
let instance = null

class Categories {
  constructor () {
    /** @type {CategoryElement[]} */
    this._categories = undefined
  }

  get categories () {
    return this._categories
  }

  async init () {
    const re = /con.*niños/ig
    this._categories = await fetchSearchCategories()
    this._categories.forEach((cat) => {
      cat.seoName = `${cat.human_name.toLowerCase()}${re.test(cat.human_name) ? '' : ' con niños'}`
    })

    return this
  }

  idToHumanName (id) {
    const cat = this.categories.find((_cat) => _cat.id === toNumber(id))
    return cat?.human_name
  }

  humanNametoId (name) {
    const cat = this.categories.find((_cat) => _cat.human_name === name)
    return cat?.id
  }

  SEOName (id) {
    const cat = this.categories.find((_cat) => _cat.id === toNumber(id))
    return cat?.seoName
  }

  idFromSEO (name) {
    const cat = this.categories.find((_cat) => _cat.seoName === name)
    return cat?.id
  }
}

export default async function getCategorySingleton () {
  if (!instance) {
    instance = new Categories()
    await instance.init()
  }

  return instance
}
